import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createAutomation } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { CreateDmAutomationReq } from '@/types/dmAutomation';

export const useCreateAutomation = () => {
    const queryClient = useQueryClient();
    return useMutation<void, unknown, CreateDmAutomationReq>({
        mutationFn: createAutomation,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.list() });
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.statsOverview() });
        },
    });
};
